export const email = 'recruiting.team@liv-research.com';



// WEBPACK FOOTER //
// ./src/custom/livres/Email.js